import { load } from '@shopify/theme-sections'
import '../sections/template-contact'

load([
  `template-contact`
])
